import React, { useState, useEffect } from 'react';
import { Table, Button, message } from 'antd';
import { EyeOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import ImageType from '../Organism/ImageType';
import ImageCategory from './ImageCategory';

interface ImageCategoryData{
    imageCategoryId:string;
    imageCategoryName:string;
    isActive:boolean;
    createdBy:string;
    createdDate:string;
    updatedBy:string;
    updatedDate:string;
    imageTypeName:string;
}

const DisplayImageCategory: React.FC = () => {
  const [imagecategorydata, setData] = useState<ImageCategoryData[]>([]);
  const [isAddImageCategoryVisible, setIsAddImageCategoryVisible] = useState(false);
  const [isEditImageCategoryVisible, setIsEditImageCategoryVisible] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

      useEffect(() => {
        getImageCategoryData();
      }, [isAddImageCategoryVisible]);

      const userId = localStorage.getItem("UserId");

      const getImageCategoryData = async () => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ImageCategory/GetImageCategory/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setData(response.data);

        } catch (error) {
          console.error("Error fetching image category details", error);
        }
      };

      const handleDeleteImageCategoryData = async (imagecategoryId: string) => {
        const confirmed = window.confirm('Are you sure you want to delete this item?');
        if(confirmed){
          try {
            const token = await fetchToken();
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/ImageCategory/DeleteImageCategory`, 
              null,
            {
              params:{
                category_id: imagecategoryId,
                user_id: userId
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            message.success('Image Category deleted successfully');
            getImageCategoryData();
          } catch (error) {
            console.error("Error deleting details", error);
          }
        }
      };

      const handleEidtImageCategoryData = async (imagecategoryId: string) => {
        setIsEditImageCategoryVisible(imagecategoryId);
        setIsAddImageCategoryVisible(!isAddImageCategoryVisible);
      };

      const columns = [
        {
            title: 'Type Name',
            dataIndex: 'imageTypeName',
            key: 'imageTypeName',
          },
          {
            title: 'Category Name',
            dataIndex: 'imageCategoryName',
            key: 'imageCategoryName',
          },
          {
            title: 'Status',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (text: boolean) => (text?"Active":"InActive"),
          },
          {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_: any, record: ImageCategoryData) => (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button icon={<DeleteOutlined />} onClick={() => handleDeleteImageCategoryData(record.imageCategoryId)}>Delete</Button>
                <Button icon={<EditOutlined />} onClick={() => handleEidtImageCategoryData(record.imageCategoryId)}>Edit</Button>
              </div>
            ),
          },
        ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
              <Button type="primary" onClick={() => setIsAddImageCategoryVisible(false)} style={{ marginRight: 8 }}>
                View Image Category
              </Button>
              <Button type="primary" onClick={() => {
                setIsAddImageCategoryVisible(true);
                setIsEditImageCategoryVisible('');
              }} style={{ marginRight: 8 }}>
                Add Image Category
              </Button>
      </div>
              {isAddImageCategoryVisible ? (<ImageCategory imgcategoryid={isEditImageCategoryVisible} />) : (<Table dataSource={imagecategorydata} columns={columns} rowKey="imageCategoryId" />)}
    </div>
  );
};

export default DisplayImageCategory;